import styled from 'styled-components';
import { hideVisually } from 'polished';
export var StyledVisuallyHidden = styled.div.withConfig({
  displayName: "VisuallyHiddenstyles__StyledVisuallyHidden",
  componentId: "sc-188vwbp-0"
})(["", ";"], hideVisually());